import { useState } from 'react';
import { api } from '../api';
import { authHeader, getToken } from '../auth';

const useAccessGate = () => {
  const [gate, setGate] = useState(null);

  const closeGate = () => setGate(null);

  const requirePremium = async () => {
    const token = getToken();
    if (!token) {
      setGate('auth');
      return false;
    }

    try {
      const { data } = await api.get('/api/auth/me', { headers: authHeader() });
      const until = data?.premium_until ? new Date(data.premium_until) : null;
      const isPremium = !!(until && until > new Date());
      if (!isPremium) {
        setGate('premium');
        return false;
      }
      return true;
    } catch {
      setGate('auth');
      return false;
    }
  };

  return { gate, requirePremium, closeGate };
};

export default useAccessGate;
